/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import {
  CommentingEventListener,
  FederatedMFE,
  LoaderType,
} from '@pwc/pwc-deals-ui';
import { isInlineCommentingEnabled } from 'common/helpers/featureFlags';

import { CommentingProps } from '../types';

const CommentingMFE: React.FC<CommentingProps> = (props: CommentingProps) => {
  const {
    contentId,
    projectId,
    isShared,
    isPreviousVersionSelected,
    isFakeClientUser,
  } = props;
  return (
    <div>
      <CommentingEventListener
        contentId={contentId as number}
        isCommentingEnabled={isInlineCommentingEnabled}
      />
      <FederatedMFE
        url={process.env.REACT_APP_COMMENTING_CONTROLLER_MFE_URL as string}
        scope="commentingController"
        reducerModule="./CommentingControllerReducers"
        componentModule="./CommentingController"
        props={{
          projectId,
          contentId,
          isShared,
          isFakeClientUser,
          commentingIdleTimeout: Number(
            process.env.REACT_APP_COMMENTING_IDLE_TIMEOUT as string
          ),
        }}
        loader={LoaderType.Circular}
      />
      <FederatedMFE
        url={process.env.REACT_APP_COMMENTING_SIDEBAR_MFE_URL as string}
        scope="commentingSidebar"
        reducerModule="./CommentingSidebarReducers"
        componentModule="./CommentingSidebar"
        props={{
          projectId,
          contentId,
          ckEditorLicenseKey: process.env.REACT_APP_CK_EDITOR_LICENSE as string,
          isShared,
          isFakeClientUser,
          commentingIdleTimeout: Number(
            process.env.REACT_APP_COMMENTING_IDLE_TIMEOUT as string
          ),
          isPreviousVersionSelected,
        }}
        loader={LoaderType.Circular}
      />
    </div>
  );
};

export default CommentingMFE;
